import React from 'react'
import { SearchkitComponent } from 'searchkit'
import NumberFormat from '../../../components/NumberFormat'
import PercentageFormat from '../../../components/PercentageFormat'
import Currency from '../../../components/Currency'

class TotalRow extends SearchkitComponent {
    getAggregateValue = propertyName => {
        const results = this.searchkit.results
        if (!results) return 0
        if (!results.aggregations) return 0
        return results.aggregations[propertyName].total.value
    }

    getTotalHits = () => {
        const results = this.searchkit.results

        if (!results) return 0
        return results.hits.total
    }

    getPercentageSold = () => {
        const sold = this.getAggregateValue('ticketsSold')
        const available = this.getAggregateValue('ticketsAvailable')
        if (available === 0) return 0
        return sold / available
    }

    renderTotalCellAsNumber = property => (
        <td className="table-number">
            <NumberFormat value={this.getAggregateValue(property)} />
        </td>
    )

    renderTotalCellAsCurrency = property => (
        <td className="table-number">
            <Currency value={this.getAggregateValue(property)} />
        </td>
    )

    render() {
        if (this.isInitialLoading()) return null

        const numberOfResults = this.searchkit.results.hits.total

        return (
            <tr className="thead-sub">
                <td colSpan="3">Totals for {numberOfResults} Events</td>
                {this.renderTotalCellAsNumber('ticketsAvailable')}
                {this.renderTotalCellAsNumber('ticketsSold')}
                {this.renderTotalCellAsNumber('ticketsSoldToday')}
                {this.renderTotalCellAsNumber('ticketsRemaining')}
                {this.renderTotalCellAsCurrency('ticketsValue')}

                <td className="table-number">
                    <PercentageFormat value={this.getPercentageSold()} />
                </td>
            </tr>
        )
    }
}

export default TotalRow
